export default function getLuminance(hex: string): number {
  // If #abc then #aabbcc
  const hexNorm: string = hex.replace(
    /^#([a-f\d])([a-f\d])([a-f\d])$/i,
    (_m: string, r: string, g: string, b: string): string => "#" + r + r + g + g + b + b,
  );

  const bigint: number = parseInt(hexNorm.slice(1), 16);
  const r: number = (bigint >> 16) & 255;
  const g: number = (bigint >> 8) & 255;
  const b: number = bigint & 255;

  // relative luminance (WCAG)
  const [R, G, B]: [number, number, number] = [r, g, b].map((c: number): number => {
    const v: number = c / 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  }) as [number, number, number];

  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

export function getContrastTextColor(hex: string): string {
  return getLuminance(hex) > 0.5 ? "#212121" : "#ffffff";
}
